import {Text} from '@ui-kitten/components';
import React from 'react';
import {Image, StyleSheet, View} from 'react-native';
import {isLandscape, px, wp} from '../../../utils';

const Cover = ({imageUrl, title}) => {
  return (
    <View style={styles.container}>
      <View style={[styles.card, styles.bgColor]}>
        <Image
          source={{uri: imageUrl}}
          resizeMode="contain"
          style={styles.image}
        />
      </View>
      <Text style={styles.title}>{title}</Text>
    </View>
  );
};

const styles = StyleSheet.create({
  container: {
    width: isLandscape() ? wp(30) : wp(96),
    marginHorizontal: wp(2),
    marginTop: px(16),
    paddingHorizontal: px(15),
    paddingVertical: px(12),
    borderRadius: 8,
    shadowColor: '#000',
    shadowOffset: {
      width: 0,
      height: 4,
    },
    shadowOpacity: 0.12,
    shadowRadius: 4.65,
    elevation: 2,
  },
  bgColor: {backgroundColor: '#F4EAEE'},
  card: {
    paddingVertical: px(10),
    borderRadius: 8,
  },
  image: {
    width: isLandscape() ? wp(30) : wp(96),
    height: isLandscape() ? wp(10) : wp(30),
    borderRadius: 8,
  },
  title: {
    marginTop: px(12),
    fontSize: px(18),
    fontWeight: '600',
    textAlign: 'center',
  },
});

export default Cover;
